var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('div',[_c('app-gridview',{attrs:{"parentData":{
        pageTitle: this.pageTitle,
        tabHeaders: this.dataHeader,
        tabItems: this.dataItems,
        isDelete: true,
    }},on:{"EditItem":function($event){return _vm.editItemHandler($event)},"NewPressed":_vm.newRecordHandler,"DeleteItem":function($event){return _vm.deleteItemHandler($event)}}}),(_vm.isConfirm)?_c('div',[_c('app-confirm',{attrs:{"parentObject":{
            messageConfirm: this.messageConfirm,
            isConfirm: this.isConfirm,
        }},on:{"confirm":_vm.deleteItemHandlerAction,"cancelConfirm":function($event){_vm.isConfirm = !_vm.isConfirm}}})],1):_vm._e(),(_vm.isErr)?_c('div',[_c('app-error',{attrs:{"parentError":{
            data: this.errMsg,
            isErr: this.isErr,
        }},on:{"closeError":function($event){_vm.isErr = $event}}})],1):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }